// extracted by mini-css-extract-plugin
export default {"title":"_8706635cca","bld":"b1f1a7af6c"};